import { render, staticRenderFns } from "./RightSideBar.vue?vue&type=template&id=1db6931c&scoped=true"
import script from "./RightSideBar.vue?vue&type=script&lang=js"
export * from "./RightSideBar.vue?vue&type=script&lang=js"
import style0 from "./RightSideBar.vue?vue&type=style&index=0&id=1db6931c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1db6931c",
  null
  
)

export default component.exports